import { z } from 'zod';

export const OtelEventTypeSchema = z.union([
    z.literal('LOG'),
    z.literal('DEBUG'),
    z.literal('JS_ERROR'),
    z.literal('ERROR'),
]);

export const OtelEventPayloadSchema = z.object({
    type: z.literal('OTEL'),
    message: z.string(),
    info: z.unknown(),
});

export type OtelEventPayload = z.infer<typeof OtelEventPayloadSchema>;
